import { Tag, TTagVariant } from "@/components/elements/Tag";
import { background, black, labelColor, state } from "@/theme/colors";
import { ECaseMatchStatus } from "@/types/enum";
import { FC, useMemo } from "react";
import { SxProps, Theme } from "@mui/material";

export type TCaseMatchStatusTagProps = {
  status: number;
  title: string;
  variant: TTagVariant;
  sx?: SxProps<Theme>;
};

export const CaseMatchStatusTag: FC<TCaseMatchStatusTagProps> = ({ status, title, variant, sx }) => {
  const commonStyleText = { "& .MuiTypography-root": { color: black[30], fontWeight: "400" } };

  type StatusConfig = { color: string; sx?: object };

  const STATUS_CONFIG: Record<ECaseMatchStatus, StatusConfig> = {
    [ECaseMatchStatus.BEFORE_PROPOSAL]: { color: background.disable, sx: commonStyleText },
    [ECaseMatchStatus.PROPOSING]: { color: labelColor.progress, sx: commonStyleText },
    [ECaseMatchStatus.UNDER_SELECTION]: { color: labelColor.progress, sx: commonStyleText },
    [ECaseMatchStatus.OFFER]: { color: labelColor.warning, sx: commonStyleText },
    [ECaseMatchStatus.OFFER_ACCEPTED]: { color: labelColor.success, sx: commonStyleText },
    [ECaseMatchStatus.ALREADY_HIRED]: { color: labelColor.success, sx: commonStyleText },
    [ECaseMatchStatus.FAILED]: { color: state.error_3, sx: commonStyleText },
    [ECaseMatchStatus.CANDIDATE_WITHDRAWN]: { color: state.error_3, sx: commonStyleText },
    [ECaseMatchStatus.OFFER_CANCELLED]: { color: state.error_3, sx: commonStyleText },
    [ECaseMatchStatus.SELECTION_CANCELLED]: { color: state.error_3, sx: commonStyleText },
  };

  const config = STATUS_CONFIG[status as keyof typeof STATUS_CONFIG];

  const tagProps = useMemo<StatusConfig>(() => {
    const baseConfig = config ?? { color: background.disable, sx: commonStyleText };

    return {
      ...baseConfig,
      sx: {
        ...baseConfig.sx,
        ...sx,
      },
    };
  }, [status, sx]);

  return <Tag variant={variant} {...tagProps} title={title} />;
};
